export class DeadlineListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            description: lang.deadline[0],
            type: lang.deadline[3],
            renewalNote: lang.deadline[1],
            created: lang.deadline[114],
            lastAction: lang.deadline[115],
            referringDate: lang.deadline[95],
            repeatingPeriod: lang.deadline[38],
            nextDeadline: lang.deadline[76],
            daysleft: lang.deadline[77],
            action: lang.deadline[86],
            attachments: lang.deadline[80],
            deadlines: lang.deadline[109],
            selectType: lang.deadline[39],
            quality: lang.deadline[124],
            safety: lang.deadline[125],
            environment: lang.deadline[126],
            administration: lang.deadline[127],
            various: lang.deadline[128],
            selectStatus: lang.deadline[146],
            all: lang.deadline[143],
            expired: lang.deadline[144],
            notExpired: lang.deadline[145],
            erase: lang.deadline[140],
            duplicate: lang.deadline[139],
            modify: lang.deadline[138],
            view: lang.deadline[7],
            documentAttachment: lang.deadline[123],
            referenceEmail: lang.deadline[4],
            requiredField: lang.general[26],
            createDeadline: lang.deadline[149],
            editDeadline: lang.deadline[107],
            save: lang.general[0],
            close: lang.general[17],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            exportPrint: lang.general[16],
            sno: lang.deadline[113],
            startingDate: lang.deadline[75],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            additionalColumns: lang.general[12],
            importTimetabledata: lang.deadline[119],
            todownloadtocsv: lang.deadline[137],
            removeallthis: lang.deadline[147],
            repetitions: lang.deadline[40],
            endDate: lang.deadline[55],
            daysnotifyError: lang.deadline[153],
            notificationTime: lang.deadline[50],
            validEmail: lang.general[73],
            submit: lang.general[37],
            enterStartdate: lang.general[80],

        }

    }

    lang() {
        return this.variables;
    }

}


export class DeadlineCreateLang {

    variables  = null;

    constructor(lang) {
        this.variables = {
            description: lang.deadline[0],
            renewalNote: lang.deadline[1],
            type: lang.deadline[3],
            documentAttachment: lang.deadline[123],
            referenceEmail: lang.deadline[4],
            quality: lang.deadline[124],
            safety: lang.deadline[125],
            environment: lang.deadline[126],
            administration: lang.deadline[127],
            various: lang.deadline[128],
            requiredField: lang.general[26],           
            created: lang.deadline[114],
            generalData: lang.deadline[142],
            lastactionPerformed: lang.deadline[141],
            lastDeadline: lang.deadline[78],
            daysleft: lang.deadline[77],
            nextDeadline: lang.deadline[132],
            attachments: lang.deadline[80],
            editOccurrence: lang.deadline[152],
            referringDate: lang.deadline[95],
            repeatingPeriod: lang.deadline[38],
            repetitions: lang.deadline[40],
            endDate: lang.deadline[55],
            daysnotifyError: lang.deadline[153],
            notificationTime: lang.deadline[50],
            save: lang.general[0],
            close: lang.general[17],
            mustbegreater: lang.deadline[154],
            daysnotify: lang.deadline[41],
            validEmail: lang.general[73],

        }
    }

    lang() {
        return this.variables;
    }

}


export class DeadlineActionLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            description: lang.deadline[0],
            type: lang.deadline[3],
            renewalNote: lang.deadline[1],
            created: lang.deadline[114],
            lastAction: lang.deadline[115],
            referringDate: lang.deadline[95],
            repeatingPeriod: lang.deadline[38],
            nextDeadline: lang.deadline[76],
            daysleft: lang.deadline[77],
            action: lang.deadline[86],
            attachments: lang.deadline[80],
            deadlines: lang.deadline[109],
            selectType: lang.deadline[39],
            quality: lang.deadline[124],
            safety: lang.deadline[125],
            environment: lang.deadline[126],
            administration: lang.deadline[127],
            various: lang.deadline[128],
            selectStatus: lang.deadline[146],
            all: lang.deadline[143],
            expired: lang.deadline[144],
            notExpired: lang.deadline[145],
            erase: lang.deadline[140],
            duplicate: lang.deadline[139],
            modify: lang.deadline[138],
            view: lang.deadline[7],
            documentAttachment: lang.deadline[123],
            referenceEmail: lang.deadline[4],
            execution_date: lang.deadline[133],
            performer: lang.deadline[87],
            outcome: lang.deadline[88],
            positive: lang.deadline[90],
            negative: lang.deadline[91],
            notes: lang.deadline[84],
            skip: lang.deadline[96],
            change: lang.deadline[93],
            donotAffect: lang.deadline[97],
            editDeadline: lang.deadline[107],
            save: lang.general[0],
            close: lang.general[17],
            generalData: lang.deadline[142],
            occurrenceData: lang.deadline[151],
            executionData: lang.deadline[133],
            option: lang.deadline[85],
            deadlineView: lang.deadline[74],
            newAction: lang.deadline[82],
            editAction: lang.deadline[156],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            exportPrint: lang.general[16],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            repetitions: lang.deadline[40],
            endDate: lang.deadline[55],
            daysnotifyError: lang.deadline[153],
            notificationTime: lang.deadline[50],


        }

    }

    lang() {
        return this.variables;
    }

}


export class DeadlineCalendarLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            description: lang.deadline[0],
            renewalNote: lang.deadline[1],
            type: lang.deadline[3],
            documentAttachment: lang.deadline[123],
            referenceEmail: lang.deadline[4],
            quality: lang.deadline[124],
            safety: lang.deadline[125],
            environment: lang.deadline[126],
            administration: lang.deadline[127],
            various: lang.deadline[128],
            month: lang.deadline[101],
            week: lang.deadline[100],
            day: lang.deadline[99],
            created: lang.deadline[114],
            previous: lang.general[101],
            next: lang.general[102],
            today: lang.general[103],                
        }

    }

    lang() {
        return this.variables;
    }

}